export const FILTER_ALL = {
  TEXT: 'notification.filter.all',
  ROLE: '0',
};

export const FILTER_READ = {
  TEXT: 'notification.filter.read',
  ROLE: '1',
};

export const FILTER_UNREAD = {
  TEXT: 'notification.filter.unread',
  ROLE: '2',
};
